document.querySelectorAll('[data-size-guide-trigger]').forEach((trigger) => {
  trigger.addEventListener('click', () => {
    const row = trigger.closest('.size-guide');
    const content = row.querySelector('[data-size-guide-content]');
    const icon = row.querySelector('[data-size-guide-icon]');
    const isOpen = content.classList.contains('active');

    content.classList.toggle('active', !isOpen);
    icon.classList.toggle('active', !isOpen);
    trigger.setAttribute('aria-expanded', String(!isOpen));
  });
});
